import { useId } from "react";
import { sanitizeAmountInput } from "@/domain/invoices/sanitizeAmountInput";

interface AmountRangeFilterProps {
  amountMin: string;
  amountMax: string;
  onChange: (patch: { amountMin?: string; amountMax?: string }) => void;
  currency?: string;
}

export function AmountRangeFilter({
  amountMin,
  amountMax,
  onChange,
  currency = "USD",
}: AmountRangeFilterProps) {
  const minId = useId();
  const maxId = useId();

  return (
    <div
      className="filter-amount min-w-0"
      title="Invoice total in account currency · leave blank for any"
    >
      <span className="filter-dates-label mb-1 block text-[0.72rem] font-semibold text-[var(--muted)]">
        Amount
      </span>
      <div className="filter-amount-inputs">
        <div className="filter-field filter-field--inline">
          <label htmlFor={minId}>Min</label>
          <span
            className="filter-amount-affix"
            title="Account default currency from Stripe"
          >
            <span className="ant-input-prefix tabular-nums" aria-hidden>
              {currency}
            </span>
            <input
              id={minId}
              type="text"
              lang="en"
              className="filter-amount-input"
              placeholder="Min"
              inputMode="decimal"
              aria-label={`Minimum invoice total in ${currency}`}
              value={amountMin}
              onChange={(e) =>
                onChange({ amountMin: sanitizeAmountInput(e.target.value) })
              }
            />
          </span>
        </div>
        <span
          className="filter-dates-sep text-center text-sm font-semibold text-[var(--muted)]"
          aria-hidden
        >
          –
        </span>
        <div className="filter-field filter-field--inline">
          <label htmlFor={maxId}>Max</label>
          <span
            className="filter-amount-affix"
            title="Account default currency from Stripe"
          >
            <span className="ant-input-prefix tabular-nums" aria-hidden>
              {currency}
            </span>
            <input
              id={maxId}
              type="text"
              lang="en"
              className="filter-amount-input"
              placeholder="Max"
              inputMode="decimal"
              aria-label={`Maximum invoice total in ${currency}`}
              value={amountMax}
              onChange={(e) =>
                onChange({ amountMax: sanitizeAmountInput(e.target.value) })
              }
            />
          </span>
        </div>
      </div>
      <p className="filter-amount-hint mt-1">
        {currency} total · blank = any
      </p>
    </div>
  );
}
